import { Validators, AbstractControl, ValidatorFn } from '@angular/forms';

import { PHONE_NUMBER_REGEX } from './regex';

export const passwordValidator = [Validators.required, Validators.minLength(8)];

export const compareValidator = (
  controlOne: AbstractControl | null,
  controlTwo: AbstractControl | null,
  message?: string | null,
  replace?: RegExp | null
): ValidatorFn => {
  return () => {
    if (replace) {
      if (
        controlOne?.value?.replace(replace, '') !==
        controlTwo?.value?.replace(replace, '')
      ) {
        return { custom: message || 'Passwords do not match' };
      }
      return null;
    }
    if (controlOne?.value !== controlTwo?.value) {
      return { custom: message || 'Passwords do not match' };
    }
    return null;
  };
};

export const phoneNumberValidator = (
  message: string = 'This field must be a valid phone number'
): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) return null;
    const valid = PHONE_NUMBER_REGEX.test(control.value);
    return valid ? null : { phoneNumberInvalid: message };
  };
};
